export default {
  'VUE_APP_COMPANY_ID': 'logimed',
  'VUE_APP_API_TOKEN': 'Test123'
}
